angular.module('TurneroApp').component('coRolesAlta', {
    bindings: {
        centroAtencionSeleccionado: '<',
        ctrlPadre: '='
    },
    controller: [
        'rolesService',
        'utilsService',
        'TurneroAppConstant',
        function (rolesService, utilsService, TurneroAppConstant) {
            var ctrl = this;

            ctrl.permisos = TurneroAppConstant.Permisos;
            ctrl.rolAlta = {};
            ctrl.listaPermisosAlta = [];
            ctrl.errores = {
                N_Rol: false,
                Descripcion: false,
                ListaPermisos: false
            };

            ctrl.$onInit = function () {
                ctrl.ctrlPadre.tLoadAlta = function () {
                    ctrl.rolAlta = {};
                    ctrl.listaPermisosAlta = [];
                    ctrl.errores = {
                        N_Rol: false,
                        Descripcion: false,
                        ListaRoles: false
                    };

                    rolesService.getInfo({ 'id_rol': '' }).$promise.then(function (res) {
                        ctrl.rolAlta = res;
                        ctrl.listaPermisosAlta = [];
                    }).catch(function (req) {
                        utilsService.errores(req);
                    });
                }
            }

            ctrl.$onChanges = function () {

            }

            ctrl.guardarRolNuevo = function () {
                ctrl.errores.ListaPermisos = !(ctrl.rolAlta.Id_Permiso_Alta);
                ctrl.errores.N_Rol = !(ctrl.rolAlta.N_Rol);
                ctrl.errores.Descripcion = !(ctrl.rolAlta.Descripcion);

                if (ctrl.errores.ListaPermisos || ctrl.errores.N_Rol || ctrl.errores.Descripcion) { return }

                rolesService.save(ctrl.rolAlta).$promise.then(function (res) {
                    ctrl.ctrlPadre.grillaReload();
                    sweetAlert("Alta Rol", "El rol se registró correctamente", "success");
                }).catch(function (req) {
                    utilsService.errores(req);
                });
            }

            ctrl.cambiosEnPermisos = function () {//funcion que recorre los permisos seleccionados en el combo y arma el string para el alta
                ctrl.rolAlta.Id_Permiso_Alta = '';

                for (var i = 0; i < ctrl.listaPermisosAlta.length; i++) {
                    ctrl.rolAlta.Id_Permiso_Alta = ctrl.rolAlta.Id_Permiso_Alta == "" ? ctrl.listaPermisosAlta[i].Id_Permiso.toString() : ctrl.rolAlta.Id_Permiso_Alta + ',' + ctrl.listaPermisosAlta[i].Id_Permiso;
                }
            };

            ctrl.cancelar = function () {
                ctrl.ctrlPadre.grillaReload();
            }
        }
    ],
    template: require('./rolesAlta.html')
});


// WEBPACK FOOTER //
// ./app/components/roles/rolesAltaComponent.js